// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactCountDto
 */
export interface IContactCountDto {
    /**
     * 
     * @type {string}
     * @memberof IContactCountDto
     */
    org_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IContactCountDto
     */
    count?: number;
}

/**
 * Check if a given object implements the IContactCountDto interface.
 */
export function instanceOfIContactCountDto(value: object): value is IContactCountDto {
    return true;
}

export function IContactCountDtoFromJSON(json: any): IContactCountDto {
    return IContactCountDtoFromJSONTyped(json, false);
}

export function IContactCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactCountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'org_name': json['org_name'] == null ? undefined : json['org_name'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function IContactCountDtoToJSON(json: any): IContactCountDto {
    return IContactCountDtoToJSONTyped(json, false);
}

export function IContactCountDtoToJSONTyped(value?: IContactCountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_name': value['org_name'],
        'count': value['count'],
    };
}

